if (!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      try {
        this.swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};
      } catch {
        this.swiperOptions = {};
      }
      const sync = () => this.syncCampaignVisibility();
      document.addEventListener('dripnord:early-access-change', sync, { signal });
      window.addEventListener('pageshow', sync, { signal });
      // New editor section markup connects automatically. Never reinitialize
      // every announcement when an unrelated section is edited.
      if (typeof Swiper === 'undefined') window.addEventListener('load', sync, { once: true, signal });
      this.syncCampaignVisibility();
    }

    disconnectedCallback() {
      this.controller?.abort();
      if (this.slider && !this.slider.destroyed) this.slider.destroy(true, true);
      this.slider = null;
      this.campaignHidden = false;
    }

    syncCampaignVisibility() {
      if (!this.isConnected) return;
      const bar = this.closest('.js-announcement-bar');
      const hiddenByCampaign = document.documentElement.dataset.dnEaState === 'active' &&
        !!bar?.querySelector('[data-dn-ea-announcement]');
      if (hiddenByCampaign) {
        if (!this.campaignHidden) this.slider?.autoplay?.stop();
        this.campaignHidden = true;
        return;
      }
      if (!this.slider || this.slider.destroyed) {
        if (typeof Swiper === 'undefined') return;
        this.initSlider(this.swiperOptions);
      } else if (this.campaignHidden) {
        // Measure only after the original content is visible again.
        this.slider.update();
        if (this.swiperOptions.autoplay) this.slider.autoplay?.start();
      }
      this.campaignHidden = false;
    }

    initSlider(swiperOptions) {
      const sliderOptions = {
        slidesPerView: swiperOptions.slidesPerView || 1,
        resistanceRatio: 0.72,
        loop: swiperOptions.loop || false,
        allowTouchMove: swiperOptions.allowTouchMove || true,
        autoplay: swiperOptions.autoplay || false,
        breakpoints: {
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 'auto',
            loop: swiperOptions.loopDesktop || swiperOptions.loop || false,
          }
        }
      };

      this.slider = new Swiper(this, sliderOptions);
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}
